import React, { useEffect } from 'react';

const Header = () => {
  useEffect(() => {
    const initMobileMenu = () => {
      const navbarToggler = document.querySelector('.navbar-toggler');
      const navbarNav = document.querySelector('.navbar-nav');

      if (navbarToggler && navbarNav) {
        const newNavbarToggler = navbarToggler.cloneNode(true);
        navbarToggler.parentNode.replaceChild(newNavbarToggler, navbarToggler);

        newNavbarToggler.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          this.classList.toggle('menu-opened');
          if (navbarNav.style.display === 'block') {
            navbarNav.style.display = 'none';
            navbarNav.classList.remove('open');
          } else {
            navbarNav.style.display = 'block';
            navbarNav.classList.add('open');
          }
        });

        const hasSubItems = document.querySelectorAll('.navbar-nav > li:has(ul)');
        hasSubItems.forEach((item) => {
          if (!item.querySelector('.submenu-button')) {
            const button = document.createElement('span');
            button.className = 'submenu-button';
            button.innerHTML = '+';
            button.style.cssText =
              'position:absolute;right:10px;top:10px;cursor:pointer;z-index:2;';
            item.style.position = 'relative';
            item.insertBefore(button, item.querySelector('ul'));

            button.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              const subMenu = this.nextElementSibling;
              if (subMenu) {
                subMenu.style.display =
                  subMenu.style.display === 'block' ? 'none' : 'block';
              }
            });
          }
        });
      }
    };

    setTimeout(initMobileMenu, 100);

    const handleResize = () => {
      if (window.innerWidth > 991) {
        const navbarNav = document.querySelector('.navbar-nav');
        if (navbarNav) {
          navbarNav.style.display = '';
          navbarNav.classList.remove('open');
        }
        const navbarToggler = document.querySelector('.navbar-toggler');
        if (navbarToggler) navbarToggler.classList.remove('menu-opened');
      }
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <style>{`
        /* ===== Botón Calculadora ===== */
        .calc-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          height: 52px;                      /* altura fija igual que Cotiza Ahora */
          padding: 0 22px;                   /* solo horizontal */
          border-radius: 0;
          background: #4a83fd;
          color: #fff !important;
          text-decoration: none !important;
          font-size: 15px;
          font-weight: bold;
          letter-spacing: 1.4px;
          text-transform: uppercase;
          line-height: 1.15;
          border: none;
          position: relative;
          overflow: hidden;
          z-index: 1;
          transition: all 0.3s linear;
          white-space: nowrap;
        }

        .calc-btn:before {
          content: "";
          position: absolute;
          top: -71px;
          right: 0;
          bottom: 0;
          width: 115%;
          height: 322%;
          left: -1px;
          transform: translateX(-100%) rotate(180deg);
          z-index: -1;
          transition: all 0.4s linear;
          background: #34da89;
        }

        .calc-btn:hover,
        .calc-btn:focus,
        .calc-btn:active {
          color: #fff !important;
        }

        .calc-btn:hover:before,
        .calc-btn:focus:before,
        .calc-btn:active:before {
          transform: translateX(0) rotate(195deg);
        }

        .calc-btn svg {
          flex-shrink: 0;
          position: relative;
          z-index: 2;
        }

        .calc-btn-text {
          display: flex;
          flex-direction: column;
          text-align: left;
          position: relative;
          z-index: 2;
          font-size: 11.5px;
          letter-spacing: 0.6px;
          line-height: 1.25;
        }

        /* Forzar misma altura al botón Cotiza Ahora */
        .attr-nav .butn-style4.md {
          height: 52px !important;
          padding: 0 24px !important;        /* solo horizontal para que coincida */
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
      `}</style>

      <header className="header-style1 menu_area-light">
        <div className="navbar-default border-bottom border-color-light-white">
          <div className="container-fluid px-lg-1-6 px-xl-2-5 px-xxl-2-9">
            <div className="row align-items-center">
              <div className="col-12 col-lg-12">
                <div className="menu_area alt-font">
                  <nav className="navbar navbar-expand-lg navbar-light p-0">
                    <div className="navbar-header navbar-header-custom">
                      <a href="/" className="navbar-brand">
                        <img
                          id="logo"
                          src="/assets/img/logos/logo-inner.png"
                          alt="logo decototal"
                        />
                      </a>
                    </div>

                    <div
                      className="navbar-toggler bg-secondary"
                      style={{ cursor: 'pointer' }}
                    ></div>

                    <ul className="navbar-nav ms-auto" id="nav">
                      <li>
                        <a href="/recubrimientos-pisos">Pisos</a>
                        <ul>
                          <li>
                            <a href="/pisos-spc-premium">
                              Piso SPC Luxury{' '}
                              <span className="menu-badge-new">Nuevo</span>
                            </a>
                          </li>
                          <li>
                            <a href="/piso-vinilico-lvt-page">
                              Piso LVT Autoadherible
                            </a>
                          </li>
                          <li>
                            <a href="/piso-deck-sintetico-page">Piso Deck</a>
                          </li>
                          <li>
                            <a href="/deck-tablon-wpc">
                              Tablones WPC{' '}
                              <span className="menu-badge-new">Nuevo</span>
                            </a>
                          </li>
                          <li>
                            <a href="/piso-de-pvc-rigido">Piso de PVC</a>
                          </li>
                          <li>
                            <a href="/piso-de-caucho-page">Piso de Caucho</a>
                          </li>
                        </ul>
                      </li>

                      <li>
                        <a href="/recubrimientos-muros">Muros y Techos </a>
                        <ul>
                          <li>
                            <a href="/muro-lambrin-concavo">
                              Muro Lambrin Cóncavo
                            </a>
                          </li>
                          <li>
                            <a href="/muro-placa-tipo-marmol-page">
                              Placa Tipo Mármol
                            </a>
                          </li>
                          <li>
                            <a href="/muro-lambrin-sintetico-page">
                              Muro Lambrin
                            </a>
                          </li>
                          <li>
                            <a href="/techo-plafon-falso-page">
                              Plafón Falso de PVC
                            </a>
                          </li>
                          <li>
                            <a href="/vigueta-wpc-page">Vigueta Wpc</a>
                          </li>
                          <li>
                            <a href="/muro-bamboo-espejo">Muro Bamboo Espejo</a>
                          </li>
                        </ul>
                      </li>

                      <li>
                        <a href="#!">Hogar </a>
                        <ul>
                          <li>
                            <a href="/escritorios-escolares">
                              Escritorios Escolares
                            </a>
                          </li>
                        </ul>
                      </li>

                      {/* Solo visible en móvil */}
                      <li className="d-lg-none">
                        <a href="/calculadora-materiales">
                          Calculadora de Materiales
                        </a>
                      </li>

                      {/* Contáctanos SIN chevron (no tiene submenú) */}
                      <li>
                        <a href="/contacto-decototal">Contáctanos</a>
                      </li>
                    </ul>

                    <div className="attr-nav align-items-xl-center ms-xl-auto main-font d-flex align-items-center gap-2">
                      {/* Botón Calculadora – azul → verde, mismo efecto que butn-style4 */}
                      <a
                        href="/calculadora-materiales"
                        className="calc-btn d-none d-lg-inline-flex"
                        aria-label="Calculadora de Materiales"
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <rect x="4" y="2" width="16" height="20" rx="2" />
                          <line x1="8" y1="6" x2="16" y2="6" />
                          <line x1="8" y1="10" x2="10" y2="10" />
                          <line x1="14" y1="10" x2="16" y2="10" />
                          <line x1="8" y1="14" x2="10" y2="14" />
                          <line x1="14" y1="14" x2="16" y2="14" />
                          <line x1="8" y1="18" x2="10" y2="18" />
                          <line x1="14" y1="18" x2="16" y2="18" />
                        </svg>
                        <span className="calc-btn-text">
                          <span>Calculadora de</span>
                          <span>Materiales</span>
                        </span>
                      </a>

                      <ul className="mb-0">
                        <li className="d-none d-xl-inline-block">
                          <a
                            href="/contacto-decototal"
                            className="butn-style4 md text-white"
                          >
                            <span>Cotiza Ahora</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;